@let kind = lifecycle.bannerKind();
@let message = lifecycle.message();
@if (kind !== 'none' && message !== null) {
  @if (collapsed()) {
    <button
      (click)="activate()"
      [attr.aria-label]="activation.labelKey() | translate"
      [attr.data-kind]="kind"
      [attr.data-link-kind]="activation.kind()"
      [attr.title]="message.key | translate: message.params"
      class="tenant-lifecycle-banner tenant-lifecycle-banner--collapsed"
      data-testid="tenant-lifecycle-banner"
      type="button"
    >
      <mat-icon aria-hidden="true" class="tenant-lifecycle-banner__icon">
        {{ kind === 'trial' ? 'schedule' : 'lock' }}
      </mat-icon>
    </button>
  } @else {
    <div
      [attr.data-kind]="kind"
      [attr.role]="kind === 'trial' ? 'status' : 'alert'"
      class="tenant-lifecycle-banner"
      data-testid="tenant-lifecycle-banner"
    >
      <div class="tenant-lifecycle-banner__header">
        <mat-icon aria-hidden="true" class="tenant-lifecycle-banner__icon">
          {{ kind === 'trial' ? 'schedule' : 'lock' }}
        </mat-icon>
        <p class="tenant-lifecycle-banner__text">{{ message.key | translate: message.params }}</p>
        @if (kind === 'trial') {
          <button
            (click)="lifecycle.dismissTrialBanner()"
            [attr.aria-label]="'TenantLifecycle.Dismiss' | translate"
            [attr.title]="'TenantLifecycle.Dismiss' | translate"
            class="tenant-lifecycle-banner__dismiss"
            data-testid="tenant-lifecycle-dismiss"
            type="button"
          >
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        }
      </div>
      <button
        (click)="activate()"
        [attr.data-link-kind]="activation.kind()"
        class="hypecast-secondary-button-small tenant-lifecycle-banner__cta"
        data-testid="tenant-lifecycle-cta"
        type="button"
      >
        {{ activation.labelKey() | translate }}
      </button>
    </div>
  }
}
